import { getAllowedPlanBackups } from './getAllowedPlanBackups/getAllowedPlanBackups';
import { getArchitecture } from './getArchitecture/getArchitecture';
import { getHighAvailabilityStatus } from './getHighAvailabilityStatus/getHighAvailabilityStatus';
import { getIsFree } from './getIsFree/getIsFree';
import { getIsPayAndGo } from './getIsPayAndGo/getIsPayAndGo';
import {
  getIsRedisFlex,
  getIsRedisFlexEssentials,
  getIsRedisFlexPro
} from './getIsRedisFlex/getIsRedisFlex';
import { getIsRof } from './getIsRof/getIsRof';
import { getType } from './getType/getType';

export const planUtils = {
  getType,
  getIsFree,
  getIsPayAndGo,
  getIsRof,
  getIsRedisFlex,
  getIsRedisFlexEssentials,
  getIsRedisFlexPro,
  getHighAvailabilityStatus,
  getAllowedPlanBackups,
  getArchitecture
};
